module.exports = __webpack_public_path__ + "static/media/HS221HJ.2061061c.jpg";